import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Access tokens are short-lived: on a 401, refresh the session once and retry.
const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status !== 401 || !cfg || cfg._retried || NO_RETRY.some((p) => cfg.url?.includes(p))) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { setTimeout(() => { refreshing = null; }, 1000); });
      await refreshing;
    } catch {
      return Promise.reject(error);
    }
    return api(cfg);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
